module.exports = __webpack_public_path__ + "img/c01_unitpriest_Normal_ua.2ce87432.webp";